export default {
    // 没有登录
    REQUIRED_TOKEN: 403,
    // 系统错误
    SYSTEM_ERROR: 2000,
    // 旧密码错误
    OLD_PWD_ERROR: 4707,
    // 开启图形验证
    REQUIRED_IMG_TOKEN: 4009,
    // 过于频繁
    CAPTCHA_TOO_OFTEN: 4008,
    // 验证码失效
    CAPTCHA_INVALID: 4003,
    // 证码错误
    CAPTCHA_ERROR: 4004
};



// WEBPACK FOOTER //
// ./src/constants/statusCode.js